import Vue from 'vue';
import { init, configureScope } from '@sentry/browser';
import { Vue as VueIntegration, Dedupe as DedupeIntegration } from '@sentry/integrations';

function meta(name) {
    const meta = document.head.querySelector(`meta[name=${name}]`);
    if(!meta) {
        console.warn(`can't find meta[name=${name}]`);
    }
    return meta?.getAttribute('content');
}

if(process.env.NODE_ENV === 'production') {
    init({
        dsn: meta('sentry-dsn'),
        environment: meta('sentry-env'),
        logger: 'javascript',
        integrations: [
            new VueIntegration({ Vue, attachProps: true }),
            new DedupeIntegration(),
        ],
        ignoreErrors: [
            'Request failed with status code 403',
            'Request failed with status code 422',
            'Avoided redundant navigation',
        ],
    });

    configureScope((scope) => {
        scope.setTag('language', 'javascript');
    });
}
